import { DatabaseCode, isDatabaseCode, toDatabaseCode, toDatabaseCodeSafely } from './database-code';
import { RrcCompanyRole, rrcCompanyRoles } from './rrc/rrc-company-role';

/**
 * The type of site.
 */
export interface SiteType extends DatabaseCode {
  disposalType?: boolean
}

const central: SiteType = {
  code: 'CENTRAL',
  displayValue: {
    id: 'ots.ui.entity.site.type.central',
    defaultMessage: 'Central'
  },
};

const pad: SiteType = {
  code: 'PAD',
  displayValue: {
    id: 'ots.ui.entity.site.type.pad',
    defaultMessage: 'Pad'
  }
};

const pond: SiteType = {
  code: 'POND',
  displayValue: {
    id: 'ots.ui.entity.site.type.pond',
    defaultMessage: 'Pond'
  }
};

const disposal: SiteType = {
  code: 'DISPOSAL',
  displayValue: {
    id: 'ots.ui.entity.site.type.disposal',
    defaultMessage: 'Disposal'
  },
  disposalType: true,
};

const recyclingFacility: SiteType = {
  code: 'RECYCLING_FACILITY',
  displayValue: {
    id: 'ots.ui.entity.site.type.recycling.facility',
    defaultMessage: 'Recycling Facility'
  },
  disposalType: true,
};

const yard: SiteType = {
  code: 'YARD',
  displayValue: {
    id: 'ots.ui.entity.site.type.yard',
    defaultMessage: 'Yard'
  }
};

const staging: SiteType = {
  code: 'STAGING',
  displayValue: {
    id: 'ots.ui.entity.site.type.staging',
    defaultMessage: 'Staging'
  }
};

export const isDisposalType = (value: SiteType | string | null | undefined): boolean => {
  if (!value) {
    return false
  }

  const dbCode = isDatabaseCode(value) ? value : toSiteType(value);
  return dbCode.disposalType === true
};

export const siteType = {
  central,
  pad,
  pond,
  disposal,
  recyclingFacility,
  yard,
  staging
};

export const siteTypes = Object.values(siteType);

export const toSiteType = (
  code: string
): SiteType => toDatabaseCode(code, siteTypes);

export const toSiteTypeSafely = (
  code: string | null | undefined,
  defaultValue: SiteType | undefined = undefined
): SiteType | undefined => toDatabaseCodeSafely(code, siteTypes, defaultValue);
